<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <img id="background_image" src="./assets/images/Asset 5.png" alt="">
    <img id="background_image" src="./assets/images/Asset 6.png" alt="">

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img id="gezond_lichaam_img" src="./assets/images/Asset 2.png" alt="">
      <img id="person_img" src="./assets/images/Asset 1.png" alt="">

      <img @click="goToStartPage()" id="start_btn" src="./assets/images/Asset 4.png" alt="">
      <img id="quit_btn" src="./assets/images/Asset 3.png" alt="">

      <img id="menu_pics_left" src="./assets/images/Asset 7.png" alt="">
      <img id="menu_pics_right" src="./assets/images/Asset 8.png" alt="">
    </span>

    <span v-show="$store.getters['app/overlays'].show_intro_overlay">
      <span v-html="texts[selected_text]" id="intro_text"></span>

      <img draggable="false" class="clickable" v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true" @click="showMenu()" id="play_start_btn_many" src="./assets/images/Asset 4.png" alt="">
      <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./assets/images/Asset 51.png" alt="">
      <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./assets/images/Asset 51.png" alt="">
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    this.checkLandscape()
  },
  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      selected_text: 0,
      texts: [
        "Wist je dat je lichaam echt heel belangrijk is? En dat je er goed voor moet zorgen? Nou, laten we samen eens praten over waarom dat zo is! <br><br> Ten eerste, voeding helpt ons groeien. Het is als brandstof voor je lichaam, net zoals benzine is voor een auto. Maar weet je wat? Niet alle soorten voedsel zijn goed voor ons. Er is iets dat we bijna elke dag eten en dat niet zo goed is voor ons lichaam: Suiker. <br><br> Suiker zit bijna overal in wat we eten, vooral in lekkere dingen zoals snoepjes, koekjes, sap en frisdranken. Suiker zorgt ervoor dat ons lichaam snel energie krijgt, maar te veel suiker is niet goed. Het kan ervoor zorgen dat je je moe en futloos voelt, en het kan ook je tanden beschadigen.",

        "Daarom is het belangrijk om gezonde keuzes te maken. Probeer in plaats van snoepjes wat fruit te eten, zoals appels, peren of druiven. En in plaats van frisdrank kun je lekker water of melk drinken. Die drankjes zijn veel beter voor je lichaam. <br><br> Dus onthoud, je lichaam is als een kostbare schat. Het is belangrijk om goed voor jezelf te zorgen door gezonde voedingskeuzes te maken. Zo blijf je sterk en gezond terwijl je opgroeit! <br><br> Doe je best en geniet van lekker eten dat goed is voor je lichaam. Jij bent belangrijk, en je verdient het om gezond en gelukkig te zijn!",

        "Ben jij benieuwd hoeveel suiker er verstopt zit in de dingen die we eten en drinken? Laten we een spannend spel spelen om erachter te komen. <br><br> Klik op de startknop om het spel te beginnen. Je ziet nu verschillende producten op het scherm, zoals frisdrank, ontbijtgranen, fruit en meer. Aan de zijkant van het scherm heb je suikerklontjes. Sleep de suikerklontjes naar de producten om te raden hoeveel suiker erin zit."
      ]
    };
  },

  methods: {
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_game_overlay: true,
      });
    },

    showMenu() {
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_game_overlay: true,
          show_intro_overlay: false,
      });
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: true,
      });
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },

    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},
}
</script>

<style>
.landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }
  
.container {
  margin: -10px;
}

#next_btn {
  position: absolute;
  margin-top: 45%;
  left: 74%;
  width: 7%;
}
#prev_btn {
  transform: rotate(180deg);
  position: absolute;
  margin-top: 45%;
  left: 21%;
  width: 7%;
}

#intro_text {
  font-family: 'LuckiestGuy';
  position: absolute;
  margin-top: 11%;
  left: 10%;
  color: white;
  font-size: 2.3vw;
  width: 80%;
  text-align: center;
  -webkit-filter: drop-shadow(1px 3px 10px #000);
    filter: drop-shadow(1px 3px 10px #000);
}

#background_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}
#background_image_2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}

#gezond_lichaam_img {
	position: absolute;
	top: 2%;
	left: 31%;
	width: 40%;
	height: auto;
}

#person_img {
	position: absolute;
	margin-top: 15%;
	left: 45%;
	width: 15%;
	height: auto;
}

body {
 cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
}

#waterpark_letters {
	position: absolute;
	margin-top: 510px;
	left: 145px;
}

#start_btn {
	cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
	position: absolute;
	margin-top: 25%;
	left: 20%;
  width: 20%;
}

#play_start_btn_many {
	position: absolute;
	margin-top: 44%;
	left: 43%;
	width: 20%;
}

#start_btn:hover {
  opacity: 0.7;
}

#quit_btn:hover {
  opacity: 0.7;
}

.clickable:hover {
  cursor: url('./assets/cursor/material-wood-pointer.png'), default;
  opacity: 0.7;
}

#quit_btn {
	cursor: url('./assets/cursor/material-wood-pointer.png'), default;
	position: absolute;
	margin-top: 25%;
	left: 61%;
  width: 20%;
}

#menu_pics_left {
	position: absolute;
	margin-top: 44%;
	left: 5%;
  width: 38%;
}

#menu_pics_right {
	position: absolute;
	margin-top: 44%;
	right: 5%;
  width: 35%;
}

.swal_html {
  font-family: "LuckiestGuy";
  src: url('./assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  font-size: 4vw;
  color: #739033;
}

.swal2-styled {
  font-family: "LuckiestGuy";
  src: url('./assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
}

body {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>
